import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import { useModals, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditPricingPlanModal from '@modals/CreateOrEditPricingPlanModal'

import PageContent from './components/PageContent'

const defaultState = {
  showCreateOrEditPricingPlanModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

const callbacks = (component: string, setState: SetState) => {
  const componentCallbacks = {
    CreateOrEditPricingPlanModal: {
      closeModal: () => setState({ showCreateOrEditPricingPlanModal: false }),
      createPricingPlan: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updatePricingPlan: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  // @ts-expect-error TS7053
  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreateOrEditPricingPlanModal,
  } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showCreateOrEditPricingPlanModal: (payload: object) => {
        setModalData('CreateOrEditPricingPlanModal', payload)
        setState({ showCreateOrEditPricingPlanModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />

        <CreateOrEditPricingPlanModal
          callbacks={callbacks('CreateOrEditPricingPlanModal', setState)}
          showModal={showCreateOrEditPricingPlanModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
